import { render, staticRenderFns } from "./ciudades.vue?vue&type=template&id=6c53b60c&scoped=true"
import script from "./ciudades.vue?vue&type=script&lang=js"
export * from "./ciudades.vue?vue&type=script&lang=js"
import style0 from "./ciudades.vue?vue&type=style&index=0&id=6c53b60c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c53b60c",
  null
  
)

export default component.exports